<template>
  <v-dialog :value="dialog" width="1200" persistent>
    <v-card class="no-scroll">
      <v-card-title class="text-h5 grey lighten-2">
        Redención por excepción
      </v-card-title>
      <v-card-text>
        <v-form ref="formBeneficio">
          <v-row style="padding-top: 30px;">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="clienteLabel"
                label="Cliente"
                outlined
                disabled
                color="#00a7e4"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model.number="formData.emision_id"
                label="Emisión"
                outlined
                disabled
                color="#00a7e4"
                :rules="required"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                :items="origenList"
                name="name"
                label="Origen"
                v-model="formData.origen"
                outlined
                primary
                disabled
                color="#00a7e4"
                :rules="required"
              />
            </v-col>
          </v-row>
          <v-row v-if="formData.emision_id">
            <v-col cols="12" md="3">
              <v-autocomplete
                :items="tipoSolicitudes"
                name="name"
                label="Tipo"
                item-text="tipo"
                item-value="tipo"
                v-model="formData.tipo"
                outlined
                primary
                disabled
                color="#00a7e4"
                :rules="required"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                :items="tiposOptions"
                name="name"
                label="Asistencia o beneficio"
                v-model="formData.tipo2"
                outlined
                primary
                clearable
                color="#00a7e4"
                :rules="required"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              v-if="formData.tipo2 != null"
            >
              <v-autocomplete
                :items="categoriasOptions"
                name="name"
                label="Categoria"
                clearable
                v-model="formData.categoria"
                outlined
                primary
                :disabled="!formData.tipo2"
                color="#00a7e4"
                :rules="required"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="formData.tipo2 != null && formData.categoria != null"
            >
              <v-autocomplete
                :items="beneficiosOptions"
                name="name"
                item-text="nombre"
                item-value="id"
                label="Asistencia / Beneficio"
                v-model="formData.beneficio_asistencia_id"
                outlined
                primary
                color="#00a7e4"
                :rules="required"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              v-if="formData.tipo2 != null && formData.categoria != null && formData.beneficio_asistencia_id != null"
            >
              <v-text-field
                v-model="formData.telefono"
                label="Número a recibir folio"
                outlined
                color="#00a7e4"
                type="tel"
                maxlength="10"
                :rules="required"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
              v-if="[1, 17, 20, 22, 23, 24].includes(formData.beneficio_asistencia_id)"
            >
              <v-text-field
                v-model="formData.telefono_saldo"
                label="Número a canjear beneficio"
                outlined
                color="#00a7e4"
                type="tel"
                maxlength="10"
                :rules="required"
              />
            </v-col>
            <v-col
              cols="12"
              md="12"
              v-if="formData.tipo2 == 'Asistencia'"
            >
              <v-autocomplete
                :items="['Titular', 'Familar', 'Titular y familiar']"
                name="name"
                label="La Redención para"
                v-model="formData.redencionPara"
                v-show="producto == null || producto.limiteFamiliares != null"
                outlined
                primary
                color="#00a7e4"
                :rules="required"
              />
            </v-col>
            <v-col
              cols="12"
              md="12"
              v-if="formData.tipo2 != null && (formData.redencionPara == 'Familar' || formData.redencionPara == 'Titular y familiar')"
            >
              <v-autocomplete
                :items="beneficiarios"
                name="name"
                item-text="valor_campo"
                item-value="id"
                label="Familiar / Beneficiario"
                v-model="formData.beneficiarios"
                outlined
                primary
                :multiple="isFamiliar"
                color="#00a7e4"
                :rules="[
                  (v) => {
                    if (!isFamiliar) return !!v || 'Debes seleccionar un beneficiario';
                    return (
                      (Array.isArray(v) && v.length > 0) ||
                      'Debes seleccionar al menos 1 beneficiario'
                    );
                  },
                ]"
              >
                <template v-slot:append-outer>
                  <v-icon
                    @click="dialogBeneficiarios = true"
                    color="#00a7e4"
                    class="mr-2"
                    style="cursor: pointer;"
                  >
                    mdi-plus-circle
                  </v-icon>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <div>
          <v-row style="text-align: end;">
            <v-col cols="12">
              <v-btn
                text
                color="#00a7e4"
                outlined
                dark
                style="border-radius: 15px;"
                @click="$emit('close')"
              >
                Cancelar
              </v-btn>
              <v-btn
                class="common-botton"
                dark
                :loading="loading"
                @click="guardar"
              >
                Guardar
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card-actions>
    </v-card>
    <CreateBeneficiarioModal
      v-if="dialogBeneficiarios"
      :currentPorcentaje="currentPorcentaje"
      :emision_id="Number(formData.emision_id)"
      :dialog="dialogBeneficiarios"
      :cerrarEvento="true"
      @closeModal="closeModalBeneficiario"
    />
  </v-dialog>
</template>

<script>
import { getAlianzasList } from "@/services/alianzas/alianzas.service.js";
import { getAlianzaByEmision } from "@/services/alianzas/alianzas.service";
import { getProductoByID } from "@/services/productos/product.service";
import { getBeneficiariosByEmisionId } from "@/services/beneficiarios/benefiario.service";
import CreateBeneficiarioModal from "@/components/commonComponents/dialogs/CreateBeneficiarioModal.vue";
import { getCategorias, getTipos } from "@/services/clubBeneficios/clubBeneficios";
import { getTipoSolicitudesForAlianzaId } from "@/services/solicitudes/Solicitudes";

export default {
  components: {
    CreateBeneficiarioModal,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        redencionPara: "Titular",
        tipo: "Redención",
        tipo2: null,
        origen: "Portal",
        emision_id: null,
        telefono: null,
        telefono_saldo: null,
        beneficiarios: [],
        categoria: null,
        beneficio_asistencia_id: null,
      },
      clienteLabel: "",
      origenList: ["Portal", "IVR", "APP", "Correo electrónico"],
      producto: null,
      alianza_intermx_id: null,
      alianzaSingle: null,
      dialogBeneficiarios: false,
      beneficiarios: [],
      categoriasOptions: [],
      tiposOptions: [],
      beneficiosOptions: [],
      tipoSolicitudes: [{ tipo: "Redención" }],
      alianzas: [],
      currentPorcentaje: 0,
      required: [(value) => !!value || "Campo Requerido"],
    };
  },
  watch: {
    dialog(value) {
      if (value) this.inicializarFormulario();
    },
    initialData: {
      deep: true,
      handler() {
        if (this.dialog) this.inicializarFormulario();
      },
    },
    "formData.redencionPara"(val) {
      if (val == "Familar" || val == "Titular y familiar") {
        this.getBeneficiariosByEmisionId();
      } else if (val == "Titular") {
        this.formData.beneficiarios = [];
      }
    },
    "formData.tipo2"(val) {
      this.formData.categoria = this.formData.categoria || null;
      this.getBeneficiosOptions();
      if (val == "Beneficio") this.formData.redencionPara = "Titular";
    },
    "formData.categoria"() {
      this.getBeneficiosOptions();
    },
    "formData.beneficio_asistencia_id"(beneficioId) {
      this.actualizarCategoriaDesdeBeneficio(beneficioId);
      if (!this.isBeneficioSaldo) this.formData.telefono_saldo = null;
    },
  },
  computed: {
    isFamiliar() {
      const asistencia = this.beneficiosOptions.find(
        (e) => e.id == this.formData.beneficio_asistencia_id
      );
      return asistencia ? !!asistencia.familiar : false;
    },
    isBeneficioSaldo() {
      return [1, 17, 20, 22, 23, 24].includes(
        this.formData.beneficio_asistencia_id
      );
    },
  },
  mounted() {
    this.getAlianzas();
    this.getTiposOptions();
  },
  methods: {
    async inicializarFormulario() {
      this.formData = {
        ...this.formData,
        tipo: "Redención",
        origen: "Portal",
        emision_id: this.initialData.emision_id || null,
        telefono: this.initialData.telefono || null,
        telefono_saldo: this.initialData.telefono_saldo || null,
        tipo2: this.initialData.tipo2 || "Asistencia",
        categoria: this.initialData.categoria || null,
        beneficio_asistencia_id: this.initialData.beneficio_asistencia_id || null,
        beneficiarios: this.initialData.beneficiarios || [],
        redencionPara: this.initialData.redencionPara || "Titular",
      };
      this.clienteLabel = this.initialData.clienteLabel || "Cliente actual";
      this.aplicarBeneficioCatalogo();
      await this.prepararDatosEmision();
      this.$nextTick(() => {
        this.$refs.formBeneficio?.resetValidation();
      });
    },
    async prepararDatosEmision() {
      if (!this.formData.emision_id) return;
      await this.fetchAlianzaByEmisionId();
      await this.getTipoSolicitudesForAlianzaId();
      await this.getCategoriasOptions();
      this.completarCategoriaDesdeBeneficio();
      this.getBeneficiosOptions();
      this.agregarBeneficioSeleccionadoAOpciones();
      this.actualizarCategoriaDesdeBeneficio(this.formData.beneficio_asistencia_id);
      await this.getBeneficiariosByEmisionId();
      if (this.initialData.productoId) await this.getProductoByID(this.initialData.productoId);
    },
    aplicarBeneficioCatalogo() {
      const beneficio =
        this.initialData.beneficioCatalogo ||
        (this.initialData.beneficiosCatalogo || []).find(
          (item) => item.id == this.formData.beneficio_asistencia_id
        );
      if (!beneficio) return;

      this.formData.tipo2 = beneficio.tipo || this.formData.tipo2;
      this.formData.categoria = beneficio.categoria || this.formData.categoria;
      this.formData.beneficio_asistencia_id =
        beneficio.id || this.formData.beneficio_asistencia_id;
      this.beneficiosOptions = [beneficio];
    },
    async getAlianzas() {
      const response = await getAlianzasList();
      this.alianzas = response.data;
    },
    async fetchAlianzaByEmisionId() {
      try {
        const response = await getAlianzaByEmision(this.formData.emision_id);
        this.alianza_intermx_id = Number(response.alianza_intermx_id);
        this.alianzaSingle = this.alianzas.find(
          (alianza) => alianza.id == this.alianza_intermx_id
        ) || null;
      } catch (error) {
        console.error("Error al obtener alianza por emision_id:", error);
        this.alianza_intermx_id = this.initialData.alianza_intermx_id || null;
      }
    },
    async getProductoByID(id) {
      try {
        const response = await getProductoByID(id);
        this.producto = response;
        if (this.producto.limiteFamiliares == null) {
          this.formData.redencionPara = "Titular";
        }
      } catch (error) {
        console.error("Error obteniendo producto:", error);
        this.producto = null;
      }
    },
    async getTiposOptions() {
      this.tiposOptions = await getTipos();
    },
    async getCategoriasOptions() {
      try {
        this.categoriasOptions = await getCategorias();
      } catch (error) {
        console.error("Error obteniendo categorías:", error);
        this.categoriasOptions = [
          ...new Set(
            this.beneficiosCatalogoFiltradoPorAlianza()
              .map((beneficio) => beneficio.categoria)
              .filter(Boolean)
          ),
        ];
      }
    },
    getBeneficiosOptions() {
      this.beneficiosOptions = this.beneficiosCatalogoFiltradoPorAlianza()
        .filter((beneficio) => !beneficio.especial);
      this.agregarBeneficioSeleccionadoAOpciones();
    },
    completarCategoriaDesdeBeneficio() {
      if (
        this.formData.categoria ||
        !this.formData.beneficio_asistencia_id
      ) {
        return;
      }

      const beneficio = this.beneficiosCatalogoFiltradoPorAlianza().find(
        (item) => item.id == this.formData.beneficio_asistencia_id
      );
      if (beneficio) {
        this.formData.tipo2 = beneficio.tipo || this.formData.tipo2;
        this.formData.categoria = beneficio.categoria || this.formData.categoria;
        this.agregarBeneficioSeleccionadoAOpciones(beneficio);
      }
    },
    actualizarCategoriaDesdeBeneficio(beneficioId) {

      if (!beneficioId) return;

      const beneficio = this.obtenerBeneficioPorId(beneficioId);
      if (!beneficio) return;

      console.log("EL BENEFICIO ES ", beneficio)

      this.formData.tipo2 = beneficio.tipo || this.formData.tipo2;
      this.formData.categoria = beneficio.categoria || this.formData.categoria;
      this.agregarBeneficioSeleccionadoAOpciones(beneficio);
    },
    obtenerBeneficioPorId(beneficioId) {
      return (
        this.beneficiosOptions.find((beneficio) => beneficio.id == beneficioId) ||
        this.beneficiosCatalogoFiltradoPorAlianza().find(
          (beneficio) => beneficio.id == beneficioId
        )
      );
    },
    agregarBeneficioSeleccionadoAOpciones(beneficioEncontrado = null) {
      const beneficio =
        beneficioEncontrado ||
        this.initialData.beneficioCatalogo ||
        this.beneficiosOptions.find(
          (item) => item.id == this.formData.beneficio_asistencia_id
        );

      if (
        !beneficio ||
        !this.formData.beneficio_asistencia_id ||
        !this.beneficioPerteneceAlianzaEmision(beneficio)
      ) {
        return;
      }

      const exists = this.beneficiosOptions.some(
        (item) => item.id == this.formData.beneficio_asistencia_id
      );
      if (!exists) {
        this.beneficiosOptions = [beneficio, ...this.beneficiosOptions];
      }
    },
    beneficiosCatalogoFiltradoPorAlianza() {
      const beneficios = this.initialData.beneficiosCatalogo || [];
      if (!this.alianza_intermx_id) return beneficios;

      const benf = beneficios.filter((beneficio) =>
        this.beneficioPerteneceAlianzaEmision(beneficio)
      );

      console.log("Beneficios filtrados ", benf)
      return benf;
    },
    beneficioPerteneceAlianzaEmision(beneficio) {
      if (!this.alianza_intermx_id) return true;

        const beneficioAlianza =
          beneficio.alianza_intermx_id ||
          beneficio.alianzaIntermxId 
      return beneficioAlianza == this.alianza_intermx_id;
    },
    async getBeneficiariosByEmisionId() {
      if (!this.formData.emision_id) return;

      const response = await getBeneficiariosByEmisionId(
        this.formData.emision_id
      );
      let currentPorcentaje = 0;
      this.beneficiarios = [];

      response.data.beneficiarios.map((e) => {
        currentPorcentaje += Number(e.porcentaje) || 0;
        this.beneficiarios.push({
          ...e,
          valor_campo: `${e.nombre || ""} ${e.apellidoPaterno ||
            ""} ${e.apellidoMaterno || ""}`.trim(),
        });
      });

      this.currentPorcentaje = currentPorcentaje;
    },
    async getTipoSolicitudesForAlianzaId() {
      if (!this.alianza_intermx_id) return;

      try {
        const response = await getTipoSolicitudesForAlianzaId(
          this.alianza_intermx_id
        );
        this.tipoSolicitudes = response.data.length
          ? response.data
          : [{ tipo: "Redención" }];
      } catch (error) {
        console.error("Error al obtener tipos de solicitudes:", error);
        this.tipoSolicitudes = [{ tipo: "Redención" }];
      }
    },
    closeModalBeneficiario() {
      this.getBeneficiariosByEmisionId();
      this.dialogBeneficiarios = false;
    },
    guardar() {
      if (!this.$refs.formBeneficio.validate()) return;

      const raw = this.formData.beneficiarios;
      const beneficiariosToArray =
        raw == null ? [] : Array.isArray(raw) ? raw : [raw];
      const payload = {
        emisionId: this.formData.emision_id,
        telefono: this.formData.telefono,
        categoria: this.formData.tipo2,
        origen: this.formData.origen,
        beneficioAsistencia: this.formData.beneficio_asistencia_id,
        redencionPara: this.formData.redencionPara ?? "Titular",
        redencionExcepcion: true,
        redimirBeneficioAsistencia: false,
        ...(this.formData.telefono_saldo && {
          celular_saldo: this.formData.telefono_saldo,
        }),
        ...(beneficiariosToArray.length > 0 && {
          beneficiarios: beneficiariosToArray,
        }),
      };

      this.$emit("save", payload);
    },
  },
};
</script>

<style scoped>
.no-scroll {
  overflow: hidden !important;
}
</style>
